export const PERCENT_MAX = 100;

export const UNAVAILABLE_IMAGE_OPACITY = 0.65;

// Keeps a `max-height` landscape query from overlapping the matching `min-height` one.
export const LANDSCAPE_HEIGHT_DELTA = 0.05;
